import React from "react";
import { ParentCompanyDashboardPage } from "@/features/dashboard";

export default function DashboardLayout() {
  return (
    <>
      <div className="main-dashboard" id="main-dashboard">
        <ParentCompanyDashboardPage />
      </div>
    </>
  );
}
